import styled from "styled-components";
import { useSelector } from "react-redux";

import { authSelector } from "../../reducers/index.js";
import { bootstrapGridBreakpoints, logoUrl } from "../utils.jsx";
import { fontFamily } from "../grid.js";
import welcomeImage from "../images/finago3D.png";

const { xs, sm, md, xl, xxl } = bootstrapGridBreakpoints;

export const DashboardHeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 3rem;
  padding: 2rem 1.0rem;
  box-shadow: 0 0 20px 0 #00000026;
  min-height: 320px;
  position: relative;
  overflow: hidden;

  @media (min-width: ${xs}) {
    flex-direction: row;
    gap: 1rem;
    padding: 1rem;
    min-height: 280px;
  }

  @media (min-width: ${sm}) {
    flex-direction: row;
    gap: 1rem;
    padding: 1rem;
    min-height: 260px;
  }

  @media (min-width: ${md}) {
    align-items: center;
    gap: 2rem;
    padding: 1.5rem;
    min-height: 192px;
  }

  @media (min-width: ${xl}) {
    gap: 3rem;
    padding: 2rem 1rem;
    min-height: 168px;
  }
`;

export const PersonalDashboardHeaderContainer = styled(DashboardHeaderContainer)`
  background: none;
  padding: 1.5rem;
  min-height: 300px;
  gap: 1.5rem;
  border-radius: 0.375rem;
  margin: -5px;
  width: 100%;

  @media (min-width: ${xs}) {
    min-height: 380px;
  }

  @media (min-width: ${md}) {
    width: 80%;
  }

  @media (min-width: ${xl}) {
    width: auto;
  }

  @media (min-width: ${xxl}) {
    min-height: 168px;
    gap: 1rem;
    border-radius: 8px;
    margin: 0;
    align-items: initial;
  }
`;

export const DashboardHeaderInfo = styled.div`
  display: flex;
  @media (min-width: ${xs}) {
    flex-direction: column;
    gap: 1rem;
  }

  @media (min-width: ${md}) {
    flex-direction: row;
  }

  @media (min-width: ${xl}) {
    gap: 3rem;
    align-items: center;
  }
`;

export const PersonalDashboardHeaderInfo = styled(DashboardHeaderInfo)`
  flex: 1;
  min-width: 0;
  flex-direction: column;
  gap: 1rem;
  align-items: baseline;

  @media (min-width: ${xxl}) {
    flex-direction: row;
    align-items: center;
    gap: 2rem;
  }
`;

export const DashboardHeaderAvatarContainer = styled.div`
  max-width: 20rem;
  max-height: 8rem;

  img {
    max-width: 7.5rem;
    aspect-ratio: 1 / 1;
    object-fit: cover;
  }
`;

export const DashboardHeaderLogoContainer = styled.div`
  max-width: 20rem;
  max-height: 8rem;
`;

export const PersonalImageContainer = styled.div.attrs({
  className: "PersonalImageContainer",
})`
  flex-shrink: 0;
  max-width: 7.5rem;
  max-height: 7.5rem;

  img {
    max-width: 7.5rem;
    aspect-ratio: 1 / 1;
    object-fit: cover;
    border-radius: 3.75rem;
  }
`;

export const HeadingName = styled.h1.attrs({ className: "HeadingName" })`
  font:
    600 25px/1 ${fontFamily},
    "Segoe UI",
    sans-serif;
  color: #0b0b14;
  text-wrap: wrap;

  @media (min-width: ${xxl}) {
    font:
      600 36px/1 ${fontFamily},
      "Segoe UI",
      sans-serif;
  }
`;

export const TodayDate = styled.h3`
  font:
    700 18px/1.2 ${fontFamily},
    "Segoe UI",
    sans-serif;
  color: #0b0b14;
  text-wrap: wrap;
  overflow-wrap: break-word;
  min-width: 0;
`;

export const WelcomeImageContainer = styled.div`
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  min-width: 30rem;
  pointer-events: none;
  z-index: -1;
`;

export const WelcomeImage = styled.img.attrs({
  src: welcomeImage,
  alt: 'Welcome',
  className: 'welcomeImage'
})`
  position: absolute;
  bottom: 0;
  right: -2.5rem;
  width: 100%;
  height: 100%;
  object-fit: contain;
  object-position: right bottom;
`;

export const DashboardHeaderLogo = () => {
  const { companyLogoUrl, companyName, company } = useSelector(authSelector);
  const organizationLogoUrl = company?.logoUrl;
  const logo = logoUrl(companyLogoUrl, organizationLogoUrl);

  return (
    <DashboardHeaderLogoContainer>
      {logo ? (
        <img src={logo} style={{maxBlockSize: "inherit"}} className="w-100" crossOrigin="anonymous" alt={companyName} />
      ) : (
        <span>{companyName}</span>
      )}
    </DashboardHeaderLogoContainer>
  );
};
